import React, { Component }          from 'react';
import color                         from 'components/color';

class PanelCorner extends Component {  
  render() {    
    
    const panelCornerStyle = {
      color           : color.yellow,
    };  
    
    return (
      <div className="panel-corner" style={ panelCornerStyle }>
        
        { this.props.children }
        
      </div>
    );
  }
}

export default PanelCorner;

  



// WEBPACK FOOTER //
// ./src/components/panel/panelCorner.js